<div class="floating-container">
    <div class="logo-image-holder">
        <img src="/assets/img/homelogo.png" class="logo-image">
    </div>
    <div style="height: 20px;"></div>
    <p class="floating-text">Temos a solução completa para o seu negócio.</p>
    <div style="height: 20px;"></div>
    <div class="small-margin">
        <button mat-raised-button color="primary" class="fill-parent-width" (click)="contactUs()">Fale Conosco</button>
    </div>
</div>